import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './select';
import {
    type AccountType,
    getLeverageSelectOptions,
    getOrderLeverageSelectOptions,
    type InstrumentType,
} from '@/utils/leverageOptions.ts';

interface LeverageSelectProps {
    value: string;
    onValueChange: (value: string) => void;
    instrumentType: InstrumentType;
    accountType?: AccountType;
    maxLeverage?: number;
    defaultLeverage?: number;
    disabled?: boolean;
    className?: string;
    placeholder?: string;
}

export const LeverageSelect: React.FC<LeverageSelectProps> = ({
    value,
    onValueChange,
    instrumentType,
    accountType = 'retail',
    maxLeverage,
    defaultLeverage,
    disabled = false,
    className = '',
    placeholder = 'Select leverage',
}) => {
    const leverageOptions =
        maxLeverage !== undefined
            ? getOrderLeverageSelectOptions(maxLeverage, defaultLeverage ?? maxLeverage)
            : getLeverageSelectOptions(instrumentType, accountType);

    return (
        <div className="space-y-2">
            <Select value={value} onValueChange={onValueChange} disabled={disabled}>
                <SelectTrigger className={className}>
                    <SelectValue placeholder={placeholder} />
                </SelectTrigger>
                <SelectContent>
                    {leverageOptions.map(option => (
                        <SelectItem key={option.value} value={option.value}>
                            {option.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
};

export default LeverageSelect;
